/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import fondo from '../../Recursos/fondo_footer.svg'
import logo from '../../Recursos/logo_blanco.svg'
import metodos from '../../Recursos/metodos.png'
import {CONTACTOS, SECCIONES} from "../../Constantes";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useIrRuta} from "../../Utilidades/useIrRuta";
import {useContext} from "react";
import {contexApp} from "../../App";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Politicas from "../Dialogos/Dialogo_Politicas";

const Footer = () => {
    const cData = useContext(contexApp)
    const {sCell, masSM} = useResponsive()
    const {ir} = useIrRuta()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Politicas})


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: 'url(' + fondo + ')',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                py: 8,
                color: '#fff'
            }}
        >

            <Dialogo/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}

            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={4}
                    >

                        <Grid container size={{xs: 12, sm: 4, md: 4}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={0}
                            >


                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <img src={logo} width={100} height={'auto'}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Typography sx={{fontSize: 14}}>
                                        La salud y bienestar de tu ser querido se construye desde sus primeros pasos

                                    </Typography>
                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 8, md: 8}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                            >

                                <Grid container size={{xs: 12, sm: 4, md: 3}} sx={{justifyContent: 'flex-start'}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        spacing={0}
                                    >

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Typography sx={{fontSize: 18, fontWeight: 600}}>Links Rapidos</Typography>
                                        </Grid>

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: 2}}>
                                            <Grid
                                                container
                                                justifyContent={'flex-start'}
                                                alignItems={'flex-start'}
                                                size={{xs: 12, sm: 12, md: 12}}
                                            >

                                                {SECCIONES.map((it, index) => {
                                                    return (
                                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                              sx={{justifyContent: 'flex-start', mt: 1}}>
                                                            <Typography
                                                                onClick={() => ir(it)}
                                                                sx={{
                                                                    cursor: 'pointer',

                                                                }}
                                                            >{it}</Typography>
                                                        </Grid>

                                                    )
                                                })}

                                            </Grid>


                                        </Grid>

                                    </Grid>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 4, md: 4}} sx={{justifyContent: 'flex-start'}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        spacing={0}
                                    >

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Typography sx={{fontSize: 18, fontWeight: 600}}>Contactos</Typography>
                                        </Grid>

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: 2}}>
                                            <Grid
                                                container
                                                justifyContent={'flex-start'}
                                                alignItems={'flex-start'}
                                                size={{xs: 12, sm: 12, md: 12}}
                                            >

                                                {CONTACTOS.map((it, index) => {
                                                    return (
                                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                              sx={{justifyContent: 'flex-start', mt: 1}}>
                                                            <Typography>{it.descripcion}</Typography>
                                                        </Grid>

                                                    )
                                                })}

                                            </Grid>


                                        </Grid>

                                    </Grid>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 4, md: 4}} sx={{justifyContent: 'flex-start'}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        spacing={0}
                                    >

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Typography sx={{fontSize: 18, fontWeight: 600}}>Politicas</Typography>
                                        </Grid>

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: 2}}>
                                            <Grid
                                                container
                                                justifyContent={'flex-start'}
                                                alignItems={'flex-start'}
                                                size={{xs: 12, sm: 12, md: 12}}
                                            >

                                                {cData.politicas.map((it, index) => {
                                                    return (
                                                        <Grid
                                                            container size={{xs: 12, sm: 12, md: 12}}
                                                            sx={{justifyContent: 'flex-start', mt: 1}}>
                                                            <Typography
                                                                onClick={() => abrir(it)}
                                                                sx={{
                                                                    cursor: 'pointer',

                                                                }}
                                                            >{it.titulo}</Typography>
                                                        </Grid>

                                                    )
                                                })}

                                            </Grid>

                                        </Grid>

                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>


                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 10}}>
                        <Grid
                            container
                            justifyContent={'center'}
                            alignItems={'center'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{maxWidth: '1400px', px: 3}}
                        >

                            <Grid container size={{xs: 12, sm: 4, md: 4}}
                                  sx={{justifyContent: !masSM ? 'center' : 'flex-start'}}>
                                <Typography sx={{textAlign: !masSM ? 'center' : 'left'}}>© Copyright 2026 - 2027 | Pet
                                    Suplise</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 4, md: 4}} sx={{justifyContent: 'center'}}>
                                <img src={metodos} width={'80%'} height={'auto'}/>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 4, md: 4}}
                                  sx={{justifyContent: !masSM ? 'center' : 'flex-end'}}>
                                <Typography sx={{textAlign: !masSM ? 'center' : 'left'}}>Pet Suplise | Argentina -
                                    Buenos
                                    Aires</Typography>
                            </Grid>

                        </Grid>
                    </Grid>

                </Grid>

            </Grid>

        </Grid>
    )

}
export default Footer